import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { AssignmentFileUploadForm } from "@/app/ProDrivers/WorkOrders/Components/Forms/AssignmentFileUploadForm";

export function AssignmentFilesDialog({
  assignmentId,
}: {
  assignmentId: string;
}) {
  return (
    <BaseDialog title="Assignment Files" size="2xl">
      <AssignmentFileUploadForm assignmentId={assignmentId} />
    </BaseDialog>
  );
}
